/**
 * Pandora tracker
 * Pandora is a IA from https://artsai.com/ to help ad partners with campaign.
 *
 * How it works?
 * PandoraTracker creates a pixel (image tag not visible to user) that send a request to artsai.com
 * to start tracking the information.
 *
 * How to use it?
 * Data Values for impression tracker:
 * data-impression="true"
 * data-pandora-impression-event='event pandora'
 * data-pandora-impression-category='event category'
 * data-pandora-impression-action='event action'
 * data-pandora-impression-label='event label'
 *
 */
(function pandoraTracker(global) {
  'use strict';

  global.NewHomeSource = global.NewHomeSource || {};
  global.NewHomeSource.Analytics = global.NewHomeSource.Analytics || {};
  const imgTemplate = `<img 
  src="https://data.adxcel-ec2.com/pixel/?ad_log=referer&action={action}&pixid=85f6ec3b-0de6-40c2-a7ac-c66fc9d90fda"
  width="1" 
  height="1" 
  border="0"
  data-pandora-pixel>`;

  const pandoraElementConfig = document.querySelector('#isPandoraActive');
  const isPandoraEnable = pandoraElementConfig && pandoraElementConfig.value === 'True';
  const previousModule = global.NewHomeSource.Analytics.PandoraTracker;
  const configurations = {
    keyAction: '{action}'
  };

  if (!isPandoraEnable) {
    global.NewHomeSource.Analytics.PandoraTracker = () => { };
    return global.NewHomeSource.Analytics.PandoraTracker;
  }

  /**
   * Pushes the google analytics event to the dataLayer.
   * @param {*} eventCategory Google analytics category name for the event.
   * @param {*} eventAction Google analytics action name for the event.
   * @param {*} eventLabel Google analytics label name for the event.
   * @param {*} eventNoInteraction Google analytics label name for the event.
   */
  function googlePush(eventCategory, eventAction, eventLabel) {
    const dataLayer = window.dataLayer;

    if (dataLayer) {
      dataLayer.push({
        event: 'GAEvent',
        eventCategory,
        eventAction,
        eventLabel,
        eventValue: undefined,
      });
    }
  }

  /**
   * @private
   * requestPixel: create a image to be logged.
   *
   * @param {string} image to be logged.
   */
  function requestPixel(image) {
    const fragment = document.createRange().createContextualFragment(image);
    document.body.appendChild(fragment);
    document.querySelector('[data-pandora-pixel]').remove();
  }

  /**
   * @constructs NewHomeSource.Analytics.PandoraTracker
   */
  function PandoraTracker(globalValues) {
    configurations.globalValues = globalValues;
  }

  /**
    * @public
    * impressionTracker: send data related to display events.
    *
    */
  PandoraTracker.impressionTracker = function impressionTracker() {
    this.forEach((element) => {
      const data = element.dataset;
      const event = data.pandoraImpressionEvent;
      if (event) {
        const pixelImage = imgTemplate.replace(configurations.keyAction, event);
        requestPixel(pixelImage);
        const category = data.pandoraImpressionCategory || undefined;
        const action = data.pandoraImpressionAction || undefined;
        const label = data.pandoraImpressionLabel || undefined;
        if (category && action) {
          googlePush(category, action, label);
        }
      }
    });
    return true;
  };

  /**
   * @public
   * identityTracker: send data related to user identification events.
   *
   */
  PandoraTracker.identityTracker = function identityTracker() {
    const data = this.caller.dataset;
    const pixelImage = imgTemplate.replace(configurations.keyAction, data.pandoraIdentity);
    requestPixel(pixelImage);
    const category = data.pandoraIdentityCategory || undefined;
    const action = data.pandoraIdentityAction || undefined;
    const label = data.pandoraIdentityLabel || undefined;
    if (category && action) {
      googlePush(category, action, label);
    }
    return true;
  };

  /**
   * @public
   * onDemandTracker: send data related to events that cannot be mapped to the HTML.
   *
   */
  PandoraTracker.onDemandTracker = function () {
    const data = Object.assign({}, this);

    if (data.event) {
      const pixelImage = imgTemplate.replace(configurations.keyAction, data.event);
      requestPixel(pixelImage);
      const category = data.pandoraCategory || undefined;
      const action = data.pandoraAction || undefined;
      const label = data.pandoraLabel || undefined;
      if (category && action) {
        googlePush(category, action, label);
      }
    }

    return true;
  };

  /**
   * @public
   * onDemandTracker: send data related to events that cannot be mapped to the HTML.
   *
   */
  PandoraTracker.eventTracker = function () {
    const data = this.dataset;
    if (data.pandoraEvent) {
      const pixelImage = imgTemplate.replace(configurations.keyAction, data.pandoraEvent);
      requestPixel(pixelImage);
      const category = data.pandoraEventCategory || undefined;
      const action = data.pandoraEventAction || undefined;
      const label = data.pandoraEventLabel || undefined;
      if (category && action) {
        googlePush(category, action, label);
      }
    }

    return true;
  };

  /**
    * @public
    * impressionTrackerSelector: returns the expression that can be used to query the DOM.
    */
  PandoraTracker.impressionTrackerSelector = function impressionTrackerSelector() {
    return 'data-pandora-impression-event';
  };

  /**
   * @public
   * identityTrackerValidator: validates if the dataset passed as parameter represents a segment pandora being tracked.
   */
  PandoraTracker.identityTrackerValidator = function identityTrackerValidator(dataset) {
    return !!dataset.pandoraIdentity;
  };

  /**
   * @public
   * onDemandTrackerValidator: validates if the data passed as parameter represents a pandora event being tracked.
   */
  PandoraTracker.onDemandTrackerValidator = function (data) {
    return data && data.eventType === 'PandoraEvent';
  };

  /**
   * @public
   * eventTrackerValidator: validates if the dataSet passed as parameter represents a pandora event being tracked.
   */
  PandoraTracker.eventTrackerValidator = function (dataSet) {
    if (dataSet.pandoraEvent) {
      return true;
    }

    return false;
  };

  /**
    * @public
    * noConflict: Returns control of NewHomeSource.Analytics.PandoraTracker to the previous script.
    */
  PandoraTracker.noConflict = function noConflict() {
    global.NewHomeSource.Analytics.PandoraTracker = previousModule;
    return PandoraTracker;
  };

  global.NewHomeSource.Analytics.PandoraTracker = PandoraTracker;

  return PandoraTracker;
}(window));
